<template>
    <div class="carats-table">
        <b-button v-b-modal.modal-1 class="carats-table-btn">{{ $t("carats-table.btn") }}</b-button>
        <b-modal size="lg" modal-class="carats-table-modal" :title="currentJewelSelection.name" id="modal-1" centered
            @show="calculateCaratsTable">
            <div class="table-responsive">
                <table>
                    <tr>
                        <th>{{ $t("carats-table.sku") }}</th>
                        <th>{{ $t("carats-table.carat") }}</th>
                        <th>{{ $t("carats-table.price") }}</th>
                        <th>{{ $t("carats-table.quantity") }}</th>
                    </tr>
                    <tbody>
                        <tr v-for="item in carats" :key="item.sku">
                            <td class="sku">{{ item.sku }}</td>
                            <td>{{ (item.placeholders.tctmix.replace(/,/, ".") > 0 ? item.placeholders.tctmix :
                                item.placeholders.tctpst) + " " + $t(`ct`) }}</td>
                            <td class="price">{{ item.price }} €</td>
                            <td><input v-model="item.quantity" class="input-pieces" type="number" min="0" @input="validatePositiveNumber(item)"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <template v-slot:modal-footer>
                <b-button class="add-to-cart-btn" variant="primary" @click="addToBasket">{{ $t("addToBasket")
                    }}</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapState } from "vuex";
import cart from '../api/cart'
export default {
    name: "CaratsTable",
    props: {
        selectObj: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            carats: []
        }
    },
    computed: {
        ...mapState({
            currentJewelSelection: (state) => state.detail.currentJewelSelection,
            rhodiumType: (state) => state.detail.rhodiumType,
            additionalValues: (state) => state.detail.additionalValues,
            additionalSkuLabelArray: (state) => state.detail.additionalSkuLabelArray,
            selectedSku: (state) => state.detail.selectedSku,
        })
    },
    methods: {
        calculateCaratsTable() {
            let vm = this;
            this.carats = [];

            let filteredKeys = Object.keys(this.currentJewelSelection.keys).filter((key) => {
                return Object.keys(vm.selectObj).every((optionName) => {
                    let stoneNumber = null;
                    let on = optionName;

                    if (optionName.startsWith("stoneColor") || optionName.startsWith("stoneSize")) {
                        let prefix = optionName.startsWith("stoneColor") ? "stoneColor" : "stoneSize";
                        on = prefix;
                        stoneNumber = optionName.substring(prefix.length);
                    }

                    if ((optionName.startsWith("stoneSize") && stoneNumber == 0) || optionName == 'rhodiumType' || optionName == 'logo' || optionName == 'writing') {
                        return true;
                    } else {
                        return vm.selectObj[optionName] == key.split("|")[vm.getOptionIndex(stoneNumber, on)];
                    }
                });
            });

            filteredKeys.forEach((key) => {
                this.carats.push({
                    ...this.currentJewelSelection.keys[key],
                    price: parseFloat(this.currentJewelSelection.keys[key].optionPrice.find(item => item.rhodiumType == this.rhodiumType).price + this.additionalValues).toFixed(2),
                    sku: this.currentJewelSelection.keys[key].sku + this.additionalSkuLabelArray.join(""),
                    quantity: 0,
                    options: {}
                });
            });

            this.carats.sort((a, b) => a.price - b.price);
        },
        getOptionIndex(stoneIndex, type) {
            return this.currentJewelSelection.options.findIndex(o => o.type == type && o.stoneNumber == stoneIndex);
        },
        validatePositiveNumber(item) {
            if (item.quantity < 0) {
                item.quantity = 0;
            }
        },
        addToBasket() {
            this.addedToBasket = true;
            cart.getCartItems(this.carats.filter(carat => carat.quantity > 0)).then((response) => {
                response.data.forEach(element => {
                    window.parent.postMessage(
                        {
                            func: "addToGioielleriaItalianaBasket",
                            message: element,
                        },
                        "*"
                    );
                });
                this.$bvModal.hide('modal-1');
            })
        }
    }
};
</script>


<style lang="scss">
.carats-table-modal {

    .sku {
        text-wrap: nowrap;
    }

    .price {
        text-wrap: nowrap;
    }

    .input-pieces {
        width: 60px;
    }

    table {
        width: 100%;
        border: collapse;
    }

    th,
    td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
    }

    .add-to-cart-btn {
        width: 100%;
        background-color: var(--primary-color-1) !important;
        color: white !important;
        text-transform: uppercase;
    }
}

.carats-table-btn {
    background-color: white !important;
    padding: 3px 10px !important;
    margin-top: 10px;
}
</style>